import React from 'react';
import PropTypes from 'prop-types';

import Booking from 'models/booking';

const propTypes = {
  booking: PropTypes.instanceOf(Booking).isRequired,
};

const PastBookingModalReceiptNumber = ({ booking }) => {
  if (!booking.onDemand) { return null; }

  return (
    <div className="text-size-12 text-weight-book margin-top-10 margin-bottom-40">
      Receipt #{booking.id}
    </div>
  );
};

PastBookingModalReceiptNumber.propTypes = propTypes;
export default PastBookingModalReceiptNumber;
